import { Link } from "react-router-dom";
import Button from "../../components/Button";
import TableFlow from "../../components/TableFlow";
import ThemeToggle from "../../components/ThemeToggle";
import style from "./style/TopBar.module.scss";
import { PiArrowRightBold } from "react-icons/pi";

type TopBarProps = {
  logoLink?: string;
  showBookADemoButton?: boolean;
};

export default function TopBar({ logoLink, showBookADemoButton }: TopBarProps) {
  return (
    <div className={style.topBar}>
      <div className="container">
        <Link to={logoLink || "/"} className={style.logo}>
          <TableFlow color />
        </Link>

        <div className={style.separator} />

        <ThemeToggle />
        {showBookADemoButton && (
          <a href="https://tableflow.com/demo" rel="noreferrer">
            <Button variants={["secondary"]} type="button" icon={<PiArrowRightBold />} iconPosition="right">
              Book a Demo
            </Button>
          </a>
        )}
      </div>
    </div>
  );
}
